import { Text, style } from '@do/walrus';
import _get from 'lodash/get';
import * as React from 'react';
import styled from 'styled-components';
import { METADATA_HEIGHT } from '../constants';
import { GetRegistrationInfo } from '../generated-types/GetRegistrationInfo';
import { VariantProps } from '../interfaces/variant';

const Container = styled.div`
  display: flex;
  align-items: center;
  padding-right: ${style.vars.whitespace.xsmall};
  border: ${style.vars.borderWidth.thin} solid ${style.colors.grey.light};
  margin: ${style.vars.whitespace.regular} 0;
  border-radius: ${style.vars.borderRadius.base};
`;

const IconCol = styled.div`
  height: ${METADATA_HEIGHT}px; /* Square column */
  width: ${METADATA_HEIGHT}px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Icon = styled.img`
  width: ${METADATA_HEIGHT * 0.6}px;
`;

const DataCol = styled.div`
  padding: ${style.vars.whitespace.small} ${style.vars.whitespace.small}
    ${style.vars.whitespace.small} 0;
  flex: 1;
`;

const Title = styled(Text)`
  font-weight: bold;
  margin-bottom: ${style.vars.whitespace.xsmall};
`;

const Description = styled(Text)`
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 0;
`;

const Metadata: React.FC<{
  data?: GetRegistrationInfo;
  variant: VariantProps;
}> = ({ data, variant }) => {
  return (
    <Container>
      <IconCol>
        <Icon src={_get(data, 'registrationFormData.marketplace_app.icon')} />
      </IconCol>
      <DataCol>
        <Title>{variant.metadata && variant.metadata.title}</Title>
        <Description>
          {variant.metadata && variant.metadata.description}
        </Description>
      </DataCol>
    </Container>
  );
};

export default Metadata;
